import { Alert, Checkbox, Col, Modal, PageHeader, Row, Tag, message } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, ButtonItem, RangePickerItem, TableItemDinamico } from "../../../Components/Items";
import SelectCuentaContableItem from "../../../Components/SelectCuentaContableItem";
import SelectProyectosItem from "../../../Components/SelectProyectosItem";

moment.locale("es");

class ReclasificacionCargosAbonos extends Component {
  tableRef = null;
  state = {
    cuentaOrigenId: undefined,
    cuentaOrigen: null,
    cuentaDestinoId: undefined,
    cuentaDestino: null,
    proyectoId: undefined,
    rangoFechas: null,
    todasCargoAbono: [],
    totalRecords: 0,
    loading: false,
    seleccionados: [],
    modalVisible: false,
    modo: null, // 'seleccion' | 'todos'
    confirmado: false,
    procesando: false,
  };

  actualizarAlcance(cambios) {
    this.setState({ ...cambios, seleccionados: [] }, () => {
      if (this.tableRef) {
        this.tableRef.updateExternalFilters(this.alcanceActual());
      }
    });
  }

  alcanceActual() {
    const { cuentaOrigenId, proyectoId, rangoFechas } = this.state;
    return {
      cuentaContableId: cuentaOrigenId,
      proyectoId: proyectoId,
      fechaInicio: rangoFechas?.[0] ? rangoFechas[0].startOf("day").toISOString() : undefined,
      fechaFin: rangoFechas?.[1] ? rangoFechas[1].endOf("day").toISOString() : undefined,
    };
  }

  consultarMovimientos(params) {
    if (!this.state.cuentaOrigenId) {
      this.setState({ todasCargoAbono: [], totalRecords: 0, loading: false });
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "cargosabonos/selectCargosAbonos",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasCargoAbono: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasCargoAbono: [], totalRecords: 0, loading: false });
        }
      })
      .catch(() => this.setState({ todasCargoAbono: [], totalRecords: 0, loading: false }));
  }

  abrirModal(modo) {
    if (modo === "seleccion" && this.state.seleccionados.length === 0) {
      return message.warning("Selecciona al menos un movimiento.");
    }
    this.setState({ modalVisible: true, modo, cuentaDestinoId: undefined, cuentaDestino: null, confirmado: false });
  }

  cerrarModal() {
    this.setState({ modalVisible: false, modo: null, cuentaDestinoId: undefined, cuentaDestino: null, confirmado: false });
  }

  confirmarReclasificacion() {
    const { modo, cuentaOrigenId, cuentaDestinoId, seleccionados } = this.state;

    if (!cuentaDestinoId || cuentaDestinoId === cuentaOrigenId) return;

    this.setState({ procesando: true });

    axios
      .post(
        "cargosabonos/reclasificarCargosAbonos",
        {
          empresaId: this.props.empresaId,
          modo,
          cuentaContableOrigenId: cuentaOrigenId,
          cuentaContableDestinoId: cuentaDestinoId,
          ...(modo === "seleccion"
            ? { cargoAbonoIds: seleccionados }
            : { proyectoId: this.state.proyectoId, fechaInicio: this.alcanceActual().fechaInicio, fechaFin: this.alcanceActual().fechaFin }),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ procesando: false });
        if (res.data.success === 2) {
          message.success(`Se reclasificaron ${res.data.movidos} movimientos a ${res.data.cuentaDestino}.`);
          if (res.data.omitidos && res.data.omitidos.length > 0) {
            message.warning(`${res.data.omitidos.length} movimiento(s) no se pudieron reclasificar (conciliados, cancelados o ya no pertenecen a la cuenta origen).`);
          }
          this.cerrarModal();
          if (this.tableRef) {
            this.tableRef.updateExternalFilters(this.alcanceActual());
          }
        } else {
          message.error(res.data.message || "No se pudo reclasificar.");
        }
      })
      .catch(() => {
        this.setState({ procesando: false });
        message.error("Error de red al reclasificar.");
      });
  }

  render() {
    const { cuentaOrigenId, cuentaDestinoId, seleccionados, totalRecords } = this.state;

    const columns = [
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        sorter: true,
        render: (value) => moment(value).locale("es").format("L"),
        width: "10%",
      },
      {
        title: "Poliza",
        dataIndex: "poliza",
        key: "poliza",
        render: (value, record) => {
          if (!value) return null;
          return `${record.tipodepoliza?.descripcion || ""}: ${value.numeroTipoPoliza} - ${value.numeroTipoTipoPoliza}`;
        },
        width: "20%",
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: "25%",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        render: (value) => value?.nombre,
        width: "15%",
      },
      {
        title: "Cargo",
        dataIndex: "cargo",
        key: "cargo",
        render: (value, record) => (value ? `${dineroDisabledMask(record.monto)} ${record.moneda?.abreviacion || ""}` : ""),
        width: "10%",
      },
      {
        title: "Abono",
        dataIndex: "cargo",
        key: "abono",
        render: (value, record) => (!value ? `${dineroDisabledMask(record.monto)} ${record.moneda?.abreviacion || ""}` : ""),
        width: "10%",
      },
      {
        title: "Conciliado",
        dataIndex: "conciliado",
        key: "conciliado",
        render: (value) => (value ? <Tag color="blue">Conciliado</Tag> : null),
        width: "10%",
      },
    ];

    return (
      <>
        <PageHeader
          title="Reclasificación masiva de Cargos y Abonos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            borderRadius: 5,
            marginBottom: 10,
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
          }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <div style={{ marginBottom: 4 }}>Cuenta Origen</div>
              <SelectCuentaContableItem
                width="100%"
                placeholder="Selecciona la cuenta origen"
                allowClear
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                value={cuentaOrigenId}
                onChange={(value, cuenta) => this.actualizarAlcance({ cuentaOrigenId: value, cuentaOrigen: cuenta })}
              />
            </Col>
            <Col span={8}>
              <div style={{ marginBottom: 4 }}>Rango de Fechas</div>
              <RangePickerItem
                style={{ width: "100%" }}
                onChange={(rangoFechas) => this.actualizarAlcance({ rangoFechas })}
              />
            </Col>
            <Col span={8}>
              <div style={{ marginBottom: 4 }}>Proyecto (opcional)</div>
              <SelectProyectosItem
                width="100%"
                allowClear
                placeholder="Todos los proyectos"
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                onChange={(value) => this.actualizarAlcance({ proyectoId: value })}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 16 }}>
            <Col span={24} style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              {seleccionados.length > 0 && (
                <ButtonItem type="primary" blanco onClick={() => this.abrirModal("seleccion")}>
                  Reclasificar seleccionados ({seleccionados.length})
                </ButtonItem>
              )}
              {cuentaOrigenId && totalRecords > 0 && (
                <ButtonItem type="primary" onClick={() => this.abrirModal("todos")}>
                  Reclasificar TODOS los movimientos de la cuenta ({totalRecords})
                </ButtonItem>
              )}
            </Col>
          </Row>
        </div>
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarMovimientos.bind(this)}
          size="small"
          dataSource={this.state.todasCargoAbono}
          columns={columns}
          rowKey="_id"
          rowSelection={{
            selectedRowKeys: this.state.seleccionados,
            onChange: (seleccionados) => this.setState({ seleccionados }),
            getCheckboxProps: (record) => ({
              disabled: record.conciliado === true,
              title: record.conciliado === true ? "Movimiento ya conciliado bancariamente, no se puede reclasificar" : undefined,
            }),
          }}
        />

        <Modal
          title="Reclasificar movimientos"
          visible={this.state.modalVisible}
          onCancel={() => this.cerrarModal()}
          onOk={() => this.confirmarReclasificacion()}
          okText="Reclasificar"
          okButtonProps={{
            danger: true,
            loading: this.state.procesando,
            disabled: !cuentaDestinoId || cuentaDestinoId === cuentaOrigenId || !this.state.confirmado,
          }}
          cancelText="Cancelar"
          destroyOnClose
        >
          <p>
            {this.state.modo === "todos"
              ? `Se moverán TODOS los movimientos (${totalRecords}) de la cuenta origen a la cuenta destino.`
              : `Se moverán los ${seleccionados.length} movimientos seleccionados a la cuenta destino.`}
          </p>
          <div style={{ marginBottom: 4 }}>Cuenta Destino</div>
          <SelectCuentaContableItem
            width="100%"
            placeholder="Selecciona la cuenta destino"
            allowClear
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            value={this.state.cuentaDestinoId}
            onChange={(value, cuenta) => this.setState({ cuentaDestinoId: value, cuentaDestino: cuenta })}
          />
          {cuentaDestinoId && cuentaDestinoId === cuentaOrigenId && (
            <Alert style={{ marginTop: 10 }} type="error" message="La cuenta destino debe ser diferente a la cuenta origen." showIcon />
          )}
          <Alert
            style={{ marginTop: 16 }}
            type="warning"
            showIcon
            message="Esta operación modifica pólizas ya contabilizadas."
            description="Si el periodo de estos movimientos ya fue declarado ante el SAT (Balanza de Comprobación, Contabilidad Electrónica, etc.), los reportes regenerados después de este cambio ya no coincidirán con lo declarado."
          />
          <Checkbox
            style={{ marginTop: 12 }}
            checked={this.state.confirmado}
            onChange={(e) => this.setState({ confirmado: e.target.checked })}
          >
            Entiendo el impacto contable de esta operación
          </Checkbox>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReclasificacionCargosAbonos);
